export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {title: 'ID', dataIndex: 'id', width: 200},
    {title: '等级编码', dataIndex: 'type', width: 200, ellipsis: true},
    {title: '等级名称', dataIndex: 'name', width: 200, ellipsis: true},
    {title: '成长值上限', dataIndex: 'growValueCapLimit', width: 200, ellipsis: true},
    {title: '成长值下限', dataIndex: 'growValueLowerLimit', width: 200, ellipsis: true},
    {title: '最后更新人', dataIndex: 'modifiedByName', width: 200, ellipsis: true},
    {title: '最后更新时间', dataIndex: 'lastUpdatedTime', width: 200, itemType: 'dateTime'},
    {title: '操作', dataIndex: 'action', fixed: 'right', width: 120, render: 'actionRender'},
  ],
  footer: [
    {label: '新增', type: 'primary', events: ['onClick:onAdd']}
  ]
}
